import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  WorkOutlineOutlined as WorkOutlineOutlinedIcon,
  StartRounded as StartRoundedIcon,
  KeyboardTabRounded as KeyboardTabRoundedIcon,
  LogoutOutlined as LogoutOutlinedIcon,
  EditLocationRounded as EditLocationRoundedIcon,
  FactCheck as FactCheckIcon,
  Construction as ConstructionIcon,
} from '@mui/icons-material';
import { DashboardWrapper } from './DashboardComponents';
import { Button, enqueueSnackbar, Typography } from '../../design-system';
import { useLogoutMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { showToRoles } from '../../utils';
import { useStore } from '../../context';

const DashboardMenuWrapper = styled(DashboardWrapper)`
  height: initial;
  margin: auto;
  width: 100%;
  max-width: 30rem;

  & > :nth-child(1) {
    margin-bottom: var(--spacing-4);
  }

  & > :nth-child(n + 2) {
    justify-content: left;
  }
`;

export const DashboardMenu = () => {
  const navigate = useNavigate();
  const { mutate } = useLogoutMutation();
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  const handleLogoutClick = async () => {
    await mutate(undefined, {
      onSuccess: () => {
        enqueueSnackbar(MESSAGES.AUTH.SUCCESS.LOG_OUT, 'success');
        navigate('/signin');
      },
    });
  };

  return (
    <DashboardMenuWrapper>
      <Typography variant={'h4'} align={'center'} weight={'bold'}>
        Menu
      </Typography>
      {showToRoles(
        [
          'SUPER_ADMIN',
          'YARD_COMPANY_ADMIN',
          'YARD_COMPANY_EMPLOYEE',
          'YARD_MANAGER',
          'YARD_DISPATCHER',
        ],
        user,
      ) && (
        <Button
          startIcon={<WorkOutlineOutlinedIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/containers')}
        >
          Containers
        </Button>
      )}
      {showToRoles(
        [
          'SUPER_ADMIN',
          'YARD_COMPANY_ADMIN',
          'YARD_COMPANY_EMPLOYEE',
          'YARD_MANAGER',
          'YARD_DISPATCHER',
        ],
        user,
      ) && (
        <Button
          startIcon={<KeyboardTabRoundedIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/gateins/add')}
        >
          Gate-in With Image
        </Button>
      )}
      {showToRoles(['YARD_CRANE_OPERATOR'], user) && (
        <Button
          startIcon={<EditLocationRoundedIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/containers/set-location')}
        >
          Set Location
        </Button>
      )}
      {showToRoles(['YARD_CRANE_OPERATOR'], user) && (
        <Button
          startIcon={<StartRoundedIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/gateouts/loaded')}
        >
          Gate-out Loaded
        </Button>
      )}
      {/* {showToRoles(
        [
          'SUPER_ADMIN',
          'YARD_COMPANY_ADMIN',
          'YARD_COMPANY_EMPLOYEE',
          'YARD_MANAGER',
          'YARD_DISPATCHER',
          'YARD_CRANE_OPERATOR',
        ],
        user,
      ) && (
        <Button
          startIcon={<StartRoundedIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/gateouts/filters')}
        >
          Gate-out by Filters
        </Button>
      )} */}
      {showToRoles(
        [
          'SUPER_ADMIN',
          'YARD_COMPANY_ADMIN',
          'YARD_COMPANY_EMPLOYEE',
          'YARD_MANAGER',
          'YARD_DISPATCHER',
        ],
        user,
      ) && (
        <Button
          startIcon={<StartRoundedIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/gateouts/complete')}
        >
          Gate-out Complete
        </Button>
      )}
      {showToRoles('client', user) && (
        <Button
          startIcon={<StartRoundedIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/gateouts/add')}
        >
          Gate-out Add
        </Button>
      )}
      {showToRoles('admin', user) && (
        <Button
          startIcon={<ConstructionIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/repairs')}
        >
          Repairs
        </Button>
      )}
      {showToRoles('admin', user) && (
        <Button
          startIcon={<ConstructionIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/repairs/add')}
        >
          Repairs Add
        </Button>
      )}
      {showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER', 'YARD_CRANE_OPERATOR'], user) && (
        <Button
          startIcon={<FactCheckIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/inventory')}
        >
          Inventory
        </Button>
      )}
      {/* {showToRoles('admin', user) && (
        <Button
          startIcon={<ConstructionIcon />}
          size={'medium'}
          onClick={() => navigate('/dashboard/repair???')}
        >
          Repair ???
        </Button>
      )} */}
      <Button
        startIcon={<LogoutOutlinedIcon />}
        data-color={'destructive'}
        size={'medium'}
        onClick={handleLogoutClick}
      >
        Logout
      </Button>
    </DashboardMenuWrapper>
  );
};
